import { format, isValid } from "date-fns";
import yaml from "js-yaml";
import { Edit, FileText, Search, Settings, Terminal } from "lucide-react";
import { ToolResponseMessageForToolPanel } from "@/components/agent/chatMessages/ToolResponseMessage";
import { AgentMessage } from "@/models/agent/message";

export const GenericToolDisplay: React.FC<{
  toolCallMessage: AgentMessage;
  toolResponseMessage?: AgentMessage | null;
}> = ({ toolCallMessage, toolResponseMessage }) => {
  // ツール情報の抽出
  let toolName = "";
  let toolArgs: Record<string, unknown> = {};
  let toolId = "";

  if (typeof toolCallMessage.content === "object" && toolCallMessage.content) {
    toolName = String(toolCallMessage.content.name || "");
    toolArgs = (toolCallMessage.content.args as Record<string, unknown>) || {};
    toolId = String(toolCallMessage.content.id || "");
  }

  // ツールアイコンの選択
  const getToolIcon = () => {
    switch (toolName) {
      case "create_file":
      case "write_file":
      case "read_file":
        return FileText;
      case "str_replace":
        return Edit;
      case "web_search":
        return Search;
      case "execute_command":
        return Terminal;
      default:
        return Settings;
    }
  };

  const IconComponent = getToolIcon();

  return (
    <>
      {/* Tool Name */}
      <div className="p-4 border-b border-gray-200">
        <div className="flex items-center gap-2">
          <IconComponent className="h-4 w-4 text-gray-500" />
          <span className="text-sm text-gray-700">{toolName}</span>
        </div>
      </div>

      {/* Tool Arguments */}
      <div className="flex-1 p-4 overflow-auto">
        <div className="space-y-4">
          {/* パラメータ表示 */}
          <div>
            <h4 className="text-sm font-medium text-gray-900 mb-2">パラメータ</h4>
            <div className="bg-gray-50 rounded-lg p-3">
              <pre className="text-xs text-gray-700 whitespace-pre-wrap break-words">
                {yaml.dump(toolArgs,{ indent: 2, lineWidth: -1, noRefs: true, sortKeys: false})}
              </pre>
            </div>
          </div>

          {/* ToolResponse Message（実行結果）表示 */}
          {toolResponseMessage && (
            <div>
              <h4 className="text-sm font-medium text-gray-900 mb-2">実行結果</h4>
              <ToolResponseMessageForToolPanel
                message={toolResponseMessage}
              />
            </div>
          )}
        </div>
      </div>

      {/* Execution Time */}
      <div className="p-4 border-t border-gray-200 text-xs text-gray-500 text-right">
        Tool ID: {toolId}
        <br />
        実行日時: {isValid(toolCallMessage.createdAt) && format(toolCallMessage.createdAt, "yyyy/M/d H:mm")}
      </div>
    </>
  );
};
